export const prettyPrice = (price, minDecimals = 2, maxDecimals = 7) => {
  let precision = minDecimals + Math.round(Math.max(0, (maxDecimals - minDecimals + 1) - price / 10))
  if (price.toFixed(precision) > 0) return price.toFixed(precision)
  else return 0
}

export const prettyValue = (value) => {
  if (value > 1000000) {
    return `${(value / 1000000).toFixed(2)}M`
  } else if (value > 1000) {
    return `${(value / 1000).toFixed(2)}K`
  } else if (value > 0) {
    return prettyPrice(value, 2, 2)
  } else return 0
}

export const min = (array, initial = 999999999) => {
  return array.reduce((min, value) => Math.min(min, value), initial)
}

export const max = (array, initial = 0) => {
  return array.reduce((max, value) => Math.max(max, value), initial)
}
